<i18n src="./resources/locales.json"></i18n>
<template>
  <v-card class="ecs-chat-now light-surface" :style="{ fontFamily: theme.getFont }">
    <v-img v-if="theme.getLogo" :src="theme.getLogo" max-height="289"></v-img>
    <v-row v-else class="ma-0 pt-6" align="center" justify="center">
      <div class="your-logo">
        {{ $t('form.logoGoesHere') }}
      </div>
    </v-row>
    <v-card-text>
      <v-form ref="form" class="form d-flex flex-column justify-center">
        <v-row class="flex-grow-0">
          <v-col cols="12" md="12">
            <v-text-field
              id="name"
              class="welcome-screen-field"
              dense
              disabled
              :label="$t('form.yourName')"
              hide-details
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="flex-grow-0">
          <v-col cols="12" md="12">
            <v-text-field
              id="email"
              class="welcome-screen-field"
              dense
              disabled
              :label="$t('form.emailAddress')"
              hide-details
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="customDateField.display" class="flex-grow-0">
          <v-col cols="12" md="12">
            <v-text-field
              id="date-picker"
              class="welcome-screen-field"
              dense
              disabled
              :label="customDateField.label"
              append-icon="mdi-calendar"
              hide-details
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="customNumberField.display" class="flex-grow-0">
          <v-col cols="12" md="12">
            <v-text-field
              id="custom-number-field"
              :label="customNumberField.label"
              class="welcome-screen-field"
              hide-details
              disabled
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="flex-grow-0">
          <v-col cols="12" md="12">
            <v-btn id="submit-button" dark block x-large color="custom-primary">
              {{ $t('form.chatNow') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'EcsCustomerWelcomeScreen',
  data() {
    return {
      datePicker: false,
      date: ''
    };
  },
  computed: {
    ...mapGetters(['theme']),
    customNumberField() {
      return (
        this.theme.getOptionalFields.customNumberField || {
          display: true,
          label: this.$t('form.customDateField')
        }
      );
    },
    customDateField() {
      return (
        this.theme.getOptionalFields.customDateField || {
          display: true,
          label: this.$t('form.customNumberField')
        }
      );
    }
  },
  methods: {
    ...mapActions(['updateOptionalField']),
    fieldUpdate(field, label, display) {
      this.updateOptionalField({ payload: { field, label, display }, vuetify: this.$vuetify });
    }
  }
};
</script>

<style scoped>
.ecs-chat-now {
  height: 100%;
  min-height: 630px;
  max-width: 500px;
  margin: auto;
}
.img-width {
  width: 100%;
  height: 100%;
}
.form {
  padding: 16px;
  width: 100%;
}
.your-logo {
  height: 150px;
  width: 200px;
  border: dashed 2px var(--v-secondary-base);
  display: flex;
  align-items: center;
  justify-content: center;
}
.grid-logo {
  grid-area: logo;
}
.grid-form {
  grid-area: form;
}
.logo-container {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
<style>
.welcome-screen-field.v-text-field.theme--dark .v-input__slot {
  background: var(--v-custom-surface-lighten1) !important;
}
.welcome-screen-field.v-text-field.theme--light .v-input__slot {
  background: var(--v-custom-surface-darken1) !important;
}
</style>
